import { Regret, PaginatedResponse, Stats, SubmitResponse, CategoryTag, SortOption } from './types';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

async function fetchJSON<T>(url: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || 'Request failed');
  }

  return response.json();
}

export async function getRegrets(
  page = 1,
  limit = 50,
  category?: CategoryTag | null,
  sort: SortOption = 'recent'
): Promise<PaginatedResponse> {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sort,
  });

  if (category) {
    params.set('category', category);
  }

  return fetchJSON<PaginatedResponse>(`/regrets?${params}`);
}

export async function getRegret(id: string): Promise<Regret> {
  return fetchJSON<Regret>(`/regret/${id}`);
}

export async function getRandomRegret(): Promise<Regret | null> {
  const result = await fetchJSON<Regret | { empty: boolean }>('/random');
  if ('empty' in result && result.empty) {
    return null;
  }
  return result as Regret;
}

export async function getStats(): Promise<Stats> {
  return fetchJSON<Stats>('/stats');
}

export async function submitRegret(text: string): Promise<SubmitResponse> {
  return fetchJSON<SubmitResponse>('/submit', {
    method: 'POST',
    body: JSON.stringify({ text }),
  });
}

export async function likeRegret(id: string): Promise<{ likes: number }> {
  return fetchJSON<{ likes: number }>(`/like/${id}`, {
    method: 'POST',
  });
}
